import React from "react";
import { NavLink } from "react-router-dom";
import { isPathActive } from "../../config/app-menu.jsx";

/**
 * Leaf or nested menu row. Parents are rendered by SidebarNav as accordion buttons.
 */
function SidebarMenuItem({ item, pathname, onNavigate }) {
  const active = isPathActive(pathname, item.match || item.path, {
    end: Boolean(item.end),
  });

  return (
    <div className={`menu-item${active ? " active" : ""}`}>
      <NavLink
        to={item.path}
        className="menu-link"
        end={Boolean(item.end)}
        onClick={onNavigate}
      >
        {item.icon ? (
          <div className="menu-icon">
            <i className={item.icon} />
          </div>
        ) : null}
        <div className="menu-text">{item.title}</div>
      </NavLink>
    </div>
  );
}

export default SidebarMenuItem;
